import { render, staticRenderFns } from "./AddStockForm.vue?vue&type=template&id=c3707622&scoped=true"
import script from "./AddStockForm.vue?vue&type=script&lang=js"
export * from "./AddStockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3707622",
  null
  
)

export default component.exports